<template>
  <div>

    <!-- Main Row -->
    <div class="row">

      <!-- Form -->
      <div class="col-md-12">
        <Card :title="'Tambah Ruangan'">
          <template v-slot:body>
            <Form
              :form="form"
              :route="'rooms'"
            />
          </template>
        </Card>
      </div>

    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue";
import Form from '@/component/masters/rooms/Form.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {

  data() {
    return {
      form: {
        name: '',
        building_id: '',
        building_name: '',
        floor: "",
        description: ''
      },
    };
  },

  components: {
    Card,
    Form
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Ruangan", route: "/masters/rooms/list" },
      { title: "Daftar Ruangan", route: "/masters/rooms/list" },
      { title: "Tambah" },
    ])
  },

}

</script>